import React, { useState } from 'react';

const CatalogoPisos = () => {
  return (
    <section>

      <style>
        {`
          .card-style3 .card-img::before,
          .card-style3 .card-img::after,
          .card-style3:hover .card-img::before,
          .card-style3:hover .card-img::after {
            background: transparent !important;
            opacity: 0 !important;
            content: none !important;
          }
        `}
      </style>

      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Conoce nuestra colección de recubrimiento para pisos</h2>
        </div>
        <div className="row mt-n1-9">
          {/* Producto 1 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/Copia%20de%20piso-spc-luxury-ventajas.jpeg"
            altText="Pisos SPC Luxury"
            codigo="Pisos SPC Luxury"
            tipo="Para Interiores"
            delay="100ms"
            link="/pisos-spc-premium"
          />
          {/* Producto 2 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-vinilicos-lvt/piso-vinilico-intro.jpg"
            altText="Pisos Vinilicos LVT"
            codigo="Pisos Vinilicos LVT"
            tipo="Para Interiores"
            delay="200ms"
            link="/piso-vinilico-lvt-page"
          />
          
          {/* Producto 3 */}
          <Producto
            imgSrc="/assets/img/productos/piso-deck-sintetico/piso-deck-sintetico-intro.jpg"
            altText="Piso Deck Sintético"
            codigo="Piso Deck Sintético"
            tipo="Para Interiores"
            delay="300ms"
            link="/piso-deck-sintetico-page"
          />
          {/* Producto 4 */}
          <Producto
            imgSrc="/assets/img/productos/piso-de-pvc-rigido/piso-de-pvc-rigido-amarillo-atras.jpg"
            altText="Pisos de PVC Rigido"
            codigo="Pisos de PVC Rigido"
            tipo="Para Interiores"
            delay="400ms"
            link="/piso-de-pvc-rigido"
          />
          {/* Producto 5 */}
          <Producto
            imgSrc="/assets/img/productos/piso-caucho-reciclado/piso-caucho-reciclado-intro.jpg"
            altText="Pisos de Caucho"
            codigo="Pisos de Caucho"
            tipo="Para Interiores"
            delay="400ms"
            link="/piso-de-caucho-page"
          />
          {/* Producto 6 */}
          <Producto
            imgSrc="/assets/img/productos/piso-deck-wpc/deck-tablon-wpc-01.png"
            altText="Tablon Deck WPC"
            codigo="Tablon Deck WPC"
            tipo="Para Exteriores"
            delay="500ms"
            link="/deck-tablon-wpc"
          />
          
        </div>
      </div>
    </section>
  );
};



//Componente (nuevo)
const Producto = ({ imgSrc, altText, codigo, tipo, delay, link }) => {
  const [hover, setHover] = useState(false);

  return (
    <div className="col-sm-6 col-lg-3 mt-1-9 wow fadeInUp" data-wow-delay={delay}>
      <a
        href={link}
        className="text-decoration-none text-reset"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div className="card card-style3 border-0 text-center h-100 d-flex flex-column">
          <div className="card-img position-relative" style={{ height: '400px', overflow: 'hidden'}}>
            <img
              src={imgSrc}
              className="card-img-top w-100 h-100"
              alt={altText}
              style={{
                objectFit: 'cover',
                transition: 'transform 0.5s ease',
                transform: hover ? 'scale(1.1)' : 'scale(1)'
              }}
            />
          </div>
          <div className="card-body p-1-9 d-flex flex-column justify-content-center flex-grow-1">
            <h3 className="h5 mb-2">{codigo}</h3>
            <p className="text-primary mb-0">{tipo}</p>
          </div>
        </div>
      </a>
    </div>
  );
};

export default CatalogoPisos;
